/**
 * A lenient email shape: no whitespace, then something, an `@`, something, a
 * dot and something. It gates a Send button so an obvious typo doesn't
 * round-trip; the server's `EmailStr` does the real validation.
 */
const EMAIL_SHAPE_RE = /^\S+@\S+\.\S+$/;

/** True when `value` has the lenient email shape of `EMAIL_SHAPE_RE`. */
export function looksLikeEmail(value: string): boolean {
  return EMAIL_SHAPE_RE.test(value);
}
